import "./generated-1784540504.css";

const A = "/generated/1784540504/assets";

const lessons = [
  ["1강: 함수의 극한", 100],
  ["2강 : 극한의 성질과 계산", 100],
  ["3강 : 극한의 성질과 계산", 100],
  ["4강 : 도함수의 활용", 74],
  ["5강 : 도함수의 그래프 활용", 0],
  ["6강 : 부정적분 기초", 0],
  ["7강 : 부정적분 기초", 0],
  ["8강 : 정적분과 넓이", 0],
] as const;

export default function Generated1784540504() {
  return (
    <main className="g0504-page">
      <aside className="g0504-sidebar">
        <div className="g0504-logo"><img src={`${A}/logo.png`} alt="내신인강" /></div>
        <button className="g0504-semester">2학년 1학기 중간<img src={`${A}/semester-chevron.png`} alt="" /></button>
        <nav className="g0504-nav">
          <img className="g0504-learning" src={`${A}/nav-learning.png`} alt="나의 학습" />
          {["과제", "직보자료", "질문", "선생님 공지", "알림", "마이페이지"].map((label) => (
            <button key={label}><span>{label}</span><b>2</b></button>
          ))}
        </nav>
      </aside>

      <section className="g0504-body">
        <div className="g0504-content">
          <header className="g0504-student-row">
            <div className="g0504-student">
              <img src={`${A}/avatar.png`} alt="" />
              <strong>이하은 학생</strong>
              <span>이화여자 강남 세화고등학교</span>
            </div>
            <button className="g0504-teacher">담당 : 한상우 선생님<img src={`${A}/teacher-chevron.png`} alt="" /></button>
          </header>

          <section className="g0504-rewards">
            <div className="g0504-streak">
              <img className="g0504-streak-bg" src={`${A}/streak-bg.png`} alt="" />
              <img className="g0504-medal" src={`${A}/streak-medal.png`} alt="" />
              <div className="g0504-streak-copy"><div><strong>연속 출석 3일 달성</strong><img src={`${A}/streak-marks.png`} alt="" /></div><span>4일만 꾸준히 출석하면&nbsp; 위클리 엠블럼 획득가능</span></div>
            </div>
            <div className="g0504-reward g0504-reward-one">
              <img className="g0504-reward-bg" src={`${A}/reward-bg-left.png`} alt="" /><img className="g0504-reward-art" src={`${A}/progress-reward.png`} alt="진도 보상 배지" />
              <div><strong>진도 보상</strong><span>3일 연속</span></div><img className="g0504-reward-chevron" src={`${A}/reward-chevron-left.png`} alt="" />
            </div>
            <div className="g0504-reward g0504-reward-two">
              <img className="g0504-reward-bg" src={`${A}/reward-bg-right.png`} alt="" /><img className="g0504-reward-art" src={`${A}/assignment-reward.png`} alt="과제 보상 배지" />
              <div><strong>과제 보상</strong><span>3일 연속</span></div><img className="g0504-reward-chevron" src={`${A}/reward-chevron-right.png`} alt="" />
            </div>
          </section>

          <section className="g0504-lower">
            <section className="g0504-exam">
              <h2>시험 정보</h2>
              <div className="g0504-exam-cols"><div><span>부교재</span><strong>쎈 수학Ⅰ + 자이스토리</strong></div><div><span>시험 기간</span><strong>26.06.24 ~ 26.06.27</strong></div><div><span>시험 범위</span><strong>함수의 극한과 연속 ~ 도함수의 활용 (접선의 방정식 또는 평균값 정리까지)</strong></div></div>
            </section>
            <section className="g0504-progress-section">
              <h2>전체 학습 진도</h2>
              <div className="g0504-lessons">
                {lessons.map(([title, progress], index) => {
                  const state = progress === 74 ? "active" : progress === 0 ? "locked" : "done";
                  return <article className={`g0504-lesson ${state}`} key={title}>
                    <div className="g0504-lesson-main"><div className="g0504-number"><img src={`${A}/lesson-${state}.png`} alt="" /><b>{index + 1}</b></div><div className="g0504-lesson-copy"><strong>{title}</strong>{progress > 0 && (progress === 74 ? <div className="g0504-progress active"><img src={`${A}/progress-active.png`} alt="진도 74%" /><span>74%</span></div> : <div className="g0504-progress"><i /><span>100%</span></div>)}</div></div>
                    {progress > 0 && <div className="g0504-status"><span>업로드 대기</span><b>{progress === 74 ? "시청 중" : "과제 제출 필요"}</b></div>}
                  </article>;
                })}
              </div>
            </section>
          </section>
        </div>
      </section>
      <button className="g0504-chat"><img className="g0504-chat-bg" src={`${A}/chat-bg.png`} alt="" /><span><img src={`${A}/chat-icon.png`} alt="" />채팅하기</span></button>
    </main>
  );
}
